export class CartQf {
  constructor() {
    this.cart = window.QF.cart;

    this.endpoints = {
      add: {
        url: 'cart/add.js',
        method: 'post'
      },
      get: {
        url: 'cart.js',
        method: 'get'
      },
      update: {
        url: 'cart/update.js',
        method: 'post'
      },
      change: {
        url: 'cart/change.js',
        method: 'post'
      },
      clear: {
        url: 'cart/clear.js',
        method: 'post'
      }
    };

    this.selectors = {
      cartDrawerContainer: '[cart-drawer-container]',
      cartTabs: '[side-cart-tab]',
      cartContent: '[side-cart-form]',
      savedCartTab: '[saved-cart-tab]',
      quickViewContainer: '[quick-view-container]',
      sideCartRecommendations: '[side-cart-recommendations]',
      sideCartRecommendationsSection: '[side-cart-recommendations-section]',
      sideCartRecommendationsContainer: '[side-cart-recommended-container]',
      cartRecommendations: '[cart-recommendations]',
      cartRecommendationsSlider: '[cart-recommendations-slider]',
      cartItemsContainer: '[cart-items-container]',
      cartCount: '[cart-count]',
      openSideCartTrigger: '[open-side-cart]',
      sideCartInner: '[side-cart-inner]',
      cartContainer: '[cart-container]',
      freeDeliveryStatus: '[free-delivery-status]',
      sideCartTotal: '[side-cart-total]',
    };
  }

  dispatchEvent(event_name, includeCart) {
    let contents = null;
    if (includeCart) {
      contents = {
        detail: {
          cart: this.cart,
        },
      };
    }
    window.dispatchEvent(new CustomEvent(event_name, contents));
  }

  async add(data) {
    try {
      const responseData = await this.request('add', data);
      this.mergeWithCurrentCart(responseData);
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_added", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async get() {
    try {
      const response = await this.request('get');
      this.cart = response.data;
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const responseData = await this.request('update', data);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async change(data) {
    try {
      const responseData = await this.request('change', data);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async remove(variant_id) {
    try {
      const updates = {
        updates: {
          [variant_id]: 0,
        }
      };
      const { data: responseData } = await this.request('update', updates);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_removed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async clear() {
    try {
      const { data: responseData } = await this.request('clear');
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("cart_cleared", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async request(key, data) {
    try {
      const url = window.Shopify.routes.root + this.endpoints[key].url;
      const method = this.endpoints[key].method;
      const headers = {
        'Content-Type': 'application/json'
      };

      const response = await fetch(url, {
        method,
        headers,
        body: JSON.stringify(data)
      });


      if (response.ok) {
        return response.json();
      } else {
        throw await response.json();
      }
    } catch (error) {

      // Generate Toasty Message
      let options = {
        title: error.message,
        message: error.description,
        delay: 5000
      }
      window.toasty.addToast(options);
      // console.log('🚀🚀🚀 ERROR: ', error);
      // console.log('🚀🚀🚀 DATA: ', data);

      throw error;
    }
  }

  mergeWithCurrentCart(data) {
    if (data.items) {
      data.items.forEach((item) => {
        let index = this.cart.items.findIndex(e => e.id === item.id);
        if (index > -1) {
          this.cart.items[index] = item;
        } else {
          this.cart.items.push(item);
        }
      });
    }
  }

  freeDeliveryProgress(el) {
    let free_delivery_amount = el.dataset.freeDelivery;
    const free_delivery_amount_market = el.dataset.freeDeliveryMarket;
    if (free_delivery_amount != '') {
      free_delivery_amount = parseFloat(free_delivery_amount);
    } else if (free_delivery_amount_market != '') {
      free_delivery_amount = JSON.parse(free_delivery_amount_market)['amount'];
    }
    if (free_delivery_amount != '') {
      const free_delivery_currency = el.dataset.currencySymbol;
      const cart_total = document.querySelector(this.selectors.sideCartTotal).dataset.subTotal / 100;
      const progress_text = el.dataset.freeProgressText;
      const reached_text = el.dataset.reachedFreeText;

      if (cart_total < free_delivery_amount) {
        const spend_more = (free_delivery_amount - cart_total).toFixed(2);
        const spend_more_formatted = Shopify.formatMoney(spend_more, free_delivery_currency);
        el.innerHTML = `${spend_more_formatted} ${progress_text}`;
      } else {
        el.innerHTML = reached_text;
      }
    }
  }

  openSideCart() {
    this.reRenderSideCart(() => {
      const cart_tabs = document.querySelectorAll(this.selectors.cartTabs);
      const cart_content = document.querySelector(this.selectors.cartContent);
      const saved_content = document.querySelector(this.selectors.savedCartTab);
      const quickview = document.querySelector(this.selectors.quickViewContainer);

      if (quickview) {
        quickview.classList.remove('active');
      }

      cart_content.style.display = 'flex';
      saved_content.style.display = 'none';

      cart_tabs[0].classList.add('active');
      cart_tabs[1].classList.remove('active');

      let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
      if (sideCartContainer) {
        sideCartContainer.classList.add("open");
        document.body.classList.add("fixed");
        sideCartContainer.style.height = window.innerHeight + "px";
        window.addEventListener("resize", () => {
          sideCartContainer.style.height = window.innerHeight + "px";
        });
        sideCartContainer.querySelector(this.selectors.sideCartRecommendations).classList.add('open');
        this.dispatchEvent("side_cart_opened", false);
      }
    });
  }

  closeSideCart() {
    let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
    if (sideCartContainer) {
      sideCartContainer.querySelector(this.selectors.sideCartRecommendations).classList.remove('open');
      sideCartContainer.classList.remove("open");
      document.body.classList.remove("fixed");
      this.dispatchEvent("side_cart_closed", false);
    }
  }

  async reRenderSideCart(successCallback = null) {
    // UPDATE CART COUNT
    const updateCartCount = () => {
      const cart = document.querySelector([this.selectors.cartItemsContainer]);
      let cart_count = cart.getAttribute('data-items-count');
      const cartCountEl = document.querySelectorAll(this.selectors.cartCount);
      const cartBtnEl = document.querySelector([this.selectors.openSideCartTrigger]);

      if (cartBtnEl && cartCountEl && cart && cart_count) {

        cartCountEl.forEach(count_el => {
          if (cart_count == 0) {
            count_el.classList.add('empty-cart');
            cartBtnEl.classList.add('empty-cart');
          } else {
            count_el.classList.remove('empty-cart');
            cartBtnEl.classList.remove('empty-cart');
          }
          count_el.innerHTML = cart_count;
        });
      }
    }

    try {
      const response = await fetch(window.Shopify.routes.root + "cart?sections=pg-side-cart");
      if (!response.ok) {
        throw new Error("Error: " + response.status);
      }
      const data = await response.json();
      const html = data["pg-side-cart"];

      const side_cart_inner = document.querySelector(this.selectors.sideCartInner);
      if (side_cart_inner && html) {
        side_cart_inner.innerHTML = html;
        const free_delivery_el = document.querySelector(this.selectors.freeDeliveryStatus);
        if (free_delivery_el) {
          this.freeDeliveryProgress(free_delivery_el);
        }
        updateCartCount();

        let first_cart_item = side_cart_inner.querySelector('.item');
        if (first_cart_item) {
          first_cart_item = first_cart_item.dataset.productId;
        }

        if (first_cart_item) {
          const productRecommendationsSection = document.querySelector(this.selectors.cartRecommendations);
          const section_id = productRecommendationsSection.dataset.sectionId;
          const recommendationsUrl = `/recommendations/products?section_id=${section_id}&product_id=${first_cart_item}&limit=5`;

          const recommendationsResponse = await fetch(recommendationsUrl);
          if (recommendationsResponse.ok) {
            const recommendationsText = await recommendationsResponse.text();
            const recommendationsHtml = document.createElement('div');
            recommendationsHtml.innerHTML = recommendationsText;
            const recommendations = recommendationsHtml.querySelector(this.selectors.cartRecommendations);
            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;
              const recommended_product_cards = productRecommendationsSection.querySelectorAll('[product-card]');
              if (recommended_product_cards.length > 0) {
                recommended_product_cards.forEach((card) => {
                  const view_text = card.dataset.cartLinkText;
                  /*
                  if (view_text != "") {
                    const productLink = card.querySelector('.product-link')
                    if (productLink) {
                      productLink.innerHTML = view_text;
                    }
                  }
                    */
                });
              }

              new window.swiper('.side-cart-recommendations-slider', {
                slidesPerView: 2.4,
                spaceBetween: 10,
                loop: true,
                breakpoints: {
                  1200: {
                    slidesPerView: 3.4
                  }
                },
                lazy: {
                  enabled: true,
                  checkInView: false,
                  loadOnTransitionStart: true,
                  loadPrevNext: true,
                  loadPrevNextAmount: 1
                },
              });
            }
          } else {
            throw new Error("Error: " + recommendationsResponse.status);
          }
        }

        if (window.innerWidth > 767.98) {
          if (first_cart_item) {
            document.querySelector(this.selectors.cartRecommendationsSlider).style.display = 'none';
            const noItemsNav = document.querySelector(this.selectors.cartRecommendationsSlider + ' + .slider-nav-wrapper');
            if (noItemsNav) {
              noItemsNav.style.display = 'none';
            }

            const productRecommendationsSection = document.querySelector(this.selectors.sideCartRecommendationsSection);
            const sectionURL = productRecommendationsSection.dataset.url;
            const sectionID = productRecommendationsSection.dataset.sectionId;
            const url = sectionURL.replace("product_id=", "product_id=" + first_cart_item);

            const sectionResponse = await fetch(url);
            if (sectionResponse.ok) {
              const sectionText = await sectionResponse.text();
              const sectionHtml = document.querySelector(this.selectors.sideCartRecommendationsContainer);
              sectionHtml.innerHTML = sectionText;

              new window.swiper(`.side-cart-recommendations-slider-${sectionID}`, {
                slidesPerView: 2,
                spaceBetween: 20,
                loop: true,
                navigation: {
                  nextEl: `.swiper-button-next.cart-rec-${sectionID}`,
                  prevEl: `.swiper-button-prev.cart-rec-${sectionID}`,
                },
                pagination: {
                  el: `.swiper-pagination.cart-rec-pagination-${sectionID}`,
                  type: "fraction",
                },
                lazy: {
                  enabled: true,
                  checkInView: false,
                  loadOnTransitionStart: true,
                  loadPrevNext: true,
                  loadPrevNextAmount: 1
                },
                breakpoints: {
                  1134: {
                    slidesPerView: 3.4,
                    spaceBetween: 20,
                  },
                  1500: {
                    slidesPerView: 3.4,
                    spaceBetween: 20,
                  },
                },
              });
            } else {
              throw new Error("Error: " + sectionResponse.status);
            }
          } else {
            new window.swiper(".cart-recommendations-slider", {
              slidesPerView: 2,
              spaceBetween: 20,
              loop: true,
              navigation: {
                nextEl: `.cart-rec-no-items.next-btn`,
                prevEl: `.cart-rec-no-items.prev-btn`,
              },
              pagination: {
                el: `.swiper-pagination.cart-rec-pagination-no-items`,
                type: "fraction",
              },
              lazy: {
                enabled: true,
                checkInView: false,
                loadOnTransitionStart: true,
                loadPrevNext: true,
                loadPrevNextAmount: 1
              },
              breakpoints: {
                1134: {
                  slidesPerView: 3.4,
                  spaceBetween: 20,
                },
                1500: {
                  slidesPerView: 3.4,
                  spaceBetween: 20,
                },
              },
            });
          }
        }
        this.cartRenderedEvent(response, html);

        const quickAdds = document.querySelectorAll('[quick-add-mobile-container].active, [quick-add-popup].active');
        if (quickAdds.length > 0) {
          quickAdds.forEach((quickAdd) => {
            quickAdd.classList.remove('active');
          });
        }

        if (successCallback) {
          successCallback();
        }
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  reRenderCart() {
    fetch(window.Shopify.routes.root + "cart?sections=pg-cart")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); // Parse the response as JSON
      })
      .then((data) => {
        let html = data["pg-cart"];
        let cart_inner = document.querySelector(this.selectors.cartContainer);
        if (cart_inner && html) {
          cart_inner.innerHTML = html;
          this.cartRenderedEvent(html);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  cartRenderedEvent(response, html) {
    const event = new CustomEvent("cart_rendered", {
      detail: {
        response,
        html,
      },
    });
    window.dispatchEvent(event);
  }
}

// export default new CartQf();
// window.CartQf = CartQf;
